import { ReactNode, useCallback, useEffect, useState } from "react"
import {
  dismissLink,
  LinkExit,
  LinkSuccess,
} from "../ReactNativePlaidLinkSDK/ReactNativePlaidLinkSDK"
import { usePlaidLink } from "../../hooks"
import { Sentry } from "../../utils"
import { Platform } from "react-native"

export function PlaidFallbackOnboardingLink(props: {
  children: ReactNode
  linkToken: string
  tokenId: string | null
  onSuccess: (params: { success: LinkSuccess; tokenId: string; layerPassed: boolean }) => void
  onExit: () => void
  onStart?: () => void
  setOpenPlaid: (ref: () => void) => void
  launchOnMount: boolean
  receivedRedirectUri?: string | null
}) {
  const {
    children,
    linkToken,
    tokenId,
    onSuccess,
    onStart,
    onExit,
    launchOnMount,
    setOpenPlaid,
    receivedRedirectUri,
  } = props
  const [alreadyLaunchedOnMount, setAlreadyLaunchedOnMount] = useState(false)

  const { startLink } = usePlaidLink({
    token: linkToken,
    receivedRedirectUri,
    onSuccess: (success: LinkSuccess) => {
      Sentry.captureMessage("PlaidLink - Success", { level: "info", extra: { success } })
      onSuccess({ success, tokenId: tokenId as string, layerPassed: false })
      if (Platform.OS === "ios") {
        dismissLink()
      }
    },
    onExit: (exit: LinkExit) => {
      Sentry.captureMessage("PlaidLink - Exit", { level: "info", extra: { error: exit } })
      onExit()
      if (Platform.OS === "ios") {
        dismissLink()
      }
    },
  })

  const linkHandle = useCallback(() => {
    if (onStart) {
      onStart()
    }
    Sentry.captureMessage("PlaidLink - Start", {
      level: "info",
      extra: { linkToken, isOAuthReturn: !!receivedRedirectUri },
    })
    startLink()
  }, [linkToken, onStart, receivedRedirectUri, startLink])

  useEffect(() => {
    setOpenPlaid(linkHandle)
  }, [setOpenPlaid, linkHandle])

  useEffect(() => {
    if (launchOnMount && !alreadyLaunchedOnMount) {
      linkHandle()
      setAlreadyLaunchedOnMount(true)
    }
  }, [launchOnMount, linkHandle, alreadyLaunchedOnMount])

  return children
}
